/**
 * The HTML element for megamenu containing megamenu items
 */
class Megamenu extends HTMLElement {
    constructor() {
        super();

        this.bindEvents = this.bindEvents.bind(this);
        this.hideMegamenu = this.hideMegamenu.bind(this);
        this.getSubmenusMaxHeight = this.getSubmenusMaxHeight.bind(this);
    }

    connectedCallback() {
        this.MegamenuEl = this;

        this.mobileBreakpoint = 1024;
        this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;

        if (this.isMobile) return;

        this.isMegamenuShow = false;
        this.mainNavigation = this.MegamenuEl.querySelector('#navigation');
        this.mainNavigationItems = this.mainNavigation?.querySelectorAll('.js-navigation-item');
        this.subNavigationItems = this.mainNavigation?.querySelectorAll('.js-navigation-submenu-item');

        // Variables
        this.timeOutNavigation = 50; // should match CSS animation
        this.submenuExtraHeight = 0; // add extra height to submenu div

        if (this.mainNavigationItems.length > 0) {
            this.getSubmenusMaxHeight(0);
            this.bindEvents();
        }
    }

    bindEvents() {
        for (let i = 0; i < this.mainNavigationItems.length; i++) {
            this.mainNavigationItems[i].addEventListener('mouseenter', (e) => {
                this.megamenuEnterTimeout = setTimeout(() => {
                    this.mainNavigationMouseenterHandler(this.mainNavigationItems[i])
                }, this.timeOutNavigation);
            });
            this.mainNavigationItems[i].addEventListener('mouseleave', () => {
                clearTimeout(this.megamenuEnterTimeout);
            });
        }

        for (let i = 0; i < this.subNavigationItems.length; i++) {
            this.subNavigationItems[i].addEventListener('mouseenter', (e) => {
                this.subNavigationMouseenterHandler(this.subNavigationItems[i])
            });
        }

        // /* Global mouse over to determine when we should start timeout function and hide megamenu */
        document.addEventListener('mouseover', (e) => {
            if(this.isMegamenuShow && !(e.target.closest('.shopify-section-header') || e.target.closest('.shopify-section-megamenu'))) {
                this.hideMegamenu();
            }
        })
    }

    mainNavigationMouseenterHandler(menuItem) {
        if (this.activeMenuItem === menuItem) { return; }

        if (this.activeMenuItem) { this.activeMenuItem.classList.remove('active') };
        // reset other menuItem
        if (this.activeSubmenuItem) { this.activeSubmenuItem.classList.remove('active')};
        if (this.activeSubitem) { this.activeSubitem.classList.remove('active')};
        this.activeSubmenuItem = this.activeSubitem = undefined;

        this.activeMenuItem = menuItem;
        menuItem.classList.add('active');
        this.isMegamenuShow = true;
        document.body.classList.add('menu-item-active');
    }

    subNavigationMouseenterHandler(submenuItem) {
        if (this.activeSubmenuItem === submenuItem) { return; }

        // submenu item
        if (this.activeSubmenuItem) { this.activeSubmenuItem.classList.remove('active')};
        submenuItem.classList.add('active');
        this.activeSubmenuItem = submenuItem;

        // subitem
        const subitem = this.MegamenuEl.querySelector(`.js-navigation-subitem[data-handler="${submenuItem.dataset.handle}"]`)
        if (this.activeSubitem) { this.activeSubitem.classList.remove('active')};
        if (!subitem) { return; }
        subitem.classList.add('active');
        this.activeSubitem = subitem;
    }

    hideMegamenu() {
        if (this.activeMenuItem) { this.activeMenuItem.classList.remove('active')};
        if (this.activeSubmenuItem) { this.activeSubmenuItem.classList.remove('active')};
        if (this.activeSubitem) { this.activeSubitem.classList.remove('active')};
        this.activeMenuItem = this.activeSubmenuItem = this.activeSubitem = undefined;

        setTimeout(() => {
            this.isMegamenuShow = false;
            document.body.classList.remove('menu-item-active');
        }, 200);
    }

    getSubmenusMaxHeight(extraHeight = 0) {
        let maxHeight = 0;
        const submenus = this.querySelectorAll('.js-navigation-submenu');
        for (const submenu of submenus) {
            maxHeight = Math.max(maxHeight, submenu.offsetHeight);
        }
        this.MegamenuEl.style.setProperty('--submenu-max-height', `${maxHeight+extraHeight}px`);
    }
}

customElements.define('w3-megamenu', Megamenu);

